import { Card, CardBody, Col, Container, Row } from "reactstrap";
import InvoiceSixPrint from "./InvoiceSixPrint";
import InvoiceSixHeader from "./InvoiceSixHeader";
import UserDetails from "./UserDetails";
import InvoiceSixTable from "./InvoiceSixTable";
import { useRef } from "react";

const InvoiceSixContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <Container>
      <div ref={contentRef}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="invoice">
                  <div>
                    <InvoiceSixHeader />
                    <hr />
                    <UserDetails />
                    <InvoiceSixTable />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <InvoiceSixPrint contentRef={contentRef} />
    </Container>
  );
};

export default InvoiceSixContainer;
